import React from 'react'
import { useAppSelector } from '../../_App/Redux/hooks'
import { ListOrganisations } from '../../_App/Redux/Slices/organisations/organisationSlice'

export default function RemiseFiltre({ t, searchfiltre, setFiltre, Filtre }: any) {
        const listOrganisation = useAppSelector(ListOrganisations)
    
    return (
        <div>
            <div className="  bg-white" style={{ padding: "10px" }}>
                <div className="row">
                    <div className="col-1">
                        <div className="form-group">
                            <label htmlFor="carte">
                                {" "}
                                <span style={{ color: "red" }}></span>
                                {t("Status")}
                            </label>
                            <select
                                className=" form-control "
                                value={Filtre.etat}
                                onChange={(e) => setFiltre((prev: any) => ({
                                    ...prev,
                                    etat: e.target.value,
                                }))}
                            >  <option key={'tout'}>{t('tout')}</option>
                                <option key={'Actif'}>{t('Actif')}</option>
                                <option key={'Inactif'}>{t('Inactif')}</option>

                            </select>

                        </div>
                    </div>
                    <div className='col-1'>
                        <div className="form-group">
                            <label htmlFor="carte">
                                {" "}
                                <span style={{ color: "red" }}></span>
                                {t("Organisation")}
                            </label>

                            <select
                                className=" form-control "
                                value={Filtre.organisation}
                                onChange={(e) => 
                                    setFiltre((prev: any) => ({
                                    ...prev,
                                    organisation: e.target.value,
                                }))}
                            >
                                {listOrganisation&&listOrganisation.map(org =>
                                    <option key={org._id} value={org._id}>
                                        {org.nom}
                                    </option>
                                )}
                                <option key="null" value={'null'}>{t('Societe')}</option>

                            </select>
                        </div>
                    </div>
                    <div className="col-2">
                        <div className="form-group">
                            <label htmlFor="carte">
                                {" "}
                                <span style={{ color: "red" }}></span>
                                {t("Date debut")}
                            </label>
                            <input
                                type="date"
                                className="form-control "
                                value={Filtre.date_debut}
                                onChange={(e) => setFiltre((prev: any) => ({
                                    ...prev,
                                    date_debut: e.target.value,
                                }))}
                            />
                        </div>
                    </div>
                    <div className="col-2">
                        <div className="form-group">
                            <label htmlFor="carte">
                                {" "}
                                <span style={{ color: "red" }}></span>
                                {t("Date fin")}
                            </label>
                            <input
                                type="date"
                                className="form-control "
                                value={Filtre.date_fin}
                                onChange={(e) => setFiltre((prev: any) => ({
                                    ...prev,
                                    date_fin: e.target.value,
                                }))}
                            
                            />
                        </div>
                    </div>
                 
                    <div className="col-1">
                        <div className="form-group">
                            <label htmlFor="carte">
                                {" "}
                                <span style={{ color: "red" }}></span>
                                {t("remise min")}
                            </label>
                            <input
                                type="number"
                                className="form-control "
                                value={Filtre.pourcentage1}
                                onChange={(e) => setFiltre((prev: any) => ({
                                    ...prev,
                                    pourcentage1: e.target.value,
                                }))}
                            />
                        </div>
                    </div>
                    <div className="col-1">
                        <div className="form-group">
                            <label htmlFor="carte">
                                {" "}
                                <span style={{ color: "red" }}></span>
                                {t("remise max ")}
                            </label>
                            <input
                                type="number"
                                className="form-control "
                                value={Filtre.pourcentage2}
                                onChange={(e) => setFiltre((prev: any) => ({
                                    ...prev,
                                    pourcentage2: e.target.value,
                                }))}
                            />
                        </div>
                    </div>
                    <div className="col-2">
                        <div className="form-group">
                            <label htmlFor="carte">
                                {" "}
                                <span style={{ color: "red" }}></span>
                                {t("Libelle")}
                            </label>
                            <input
                                type="text"
                                className="form-control "
                                value={Filtre.libelle}
                                onChange={(e) => setFiltre((prev: any) => ({
                                    ...prev,
                                    libelle: e.target.value,
                                }))}
                            />
                        </div>
                    </div>
                    <div className="col-1 mt-4">
                        <button className="btn btn-primary-app" onClick={searchfiltre}>
                            {t("chercher")}
                        </button>
                    </div>

                </div>
            </div>




        </div >
    )
}
